module.exports = __webpack_public_path__ + "img/122.68b40571.png";